import React from "react";

const AboutAreaOne = () => {
  return (
    <>
      <div className='about-area pt-3 pt-md-5'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-6'>
              <div
                className='about-thumb-inner pe-xl-5 me-xl-5 text-center'
                data-aos='fade-right'
                data-aos-delay='100'
                data-aos-duration='1500'
              >
                <img
                  className='d-none d-lg-block animate-img-1 top_image_bounce'
                  src='/assets/img/about/2.png'
                  alt='img'
                />
                <img
                  className='d-none d-lg-block animate-img-2 left_image_bounce'
                  src='/assets/img/about/3.png'
                  alt='img'
                />
                <img
                  className='d-none d-lg-block animate-img-3 top_image_bounce'
                  src='/assets/img/banner/5.svg'
                  alt='img'
                />
                <img
                  className='main-img'
                  src='/assets/img/about/team.webp'
                  alt='img'
                />
              </div>
            </div>
            <div
              className='col-lg-6 '
              data-aos='fade-left'
              data-aos-delay='100'
              data-aos-duration='1500'
            >
              <div className='section-title mt-5 mt-lg-0'>
                <h6 className='sub-title text-uppercase'>About Us</h6>
                <h2 className='title'>
                  Crafting Innovative <span>Solutions</span> for Businesses
                </h2>
                <p className='content mb-4 mb-xl-5'>
                  At Bchu Software, we believe in the power of technology to transform businesses. Founded with a
                  vision to provide top-tier web development services, we specialize in creating custom web solutions
                  that help companies thrive in an ever-evolving digital landscape.
                </p>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='single-about-inner'>
                      <div className='thumb mb-3'>
                        <img src='/assets/img/icon/2.png' alt='img' />
                      </div>
                      <div className='details'>
                        <h5>Our Mission</h5>
                        <p>
                          To empower businesses by delivering tailored, innovative software solutions that drives growth,
                          enhances efficiency, and maximizes impact.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='single-about-inner'>
                      <div className='thumb mb-3'>
                        <img src='/assets/img/icon/3.png' alt='img' />
                      </div>
                      <div className='details'>
                        <h5>Our Approach</h5>
                        <p>
                          We prioritize understanding your business needs to deliver tailored solutions. From concept to
                          deployment, we focus on building scalable, secure, and user-friendly applications.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutAreaOne;
